/*
 * @Author: redu125 alSZBayxDwQnKd60.redu125@noreply.gitcode.com
 * @Date: 2026-09-18 10:07:24
 * @LastEditors: redu125 alSZBayxDwQnKd60.redu125@noreply.gitcode.com
 * @LastEditTime: 2026-10-10 10:34:14
 * @FilePath: \watherfocast2\src\api\config.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 接口地址统一配置：切换环境/域名只需修改本文件
export const API_BASE = 'https://www.moodsci.com/lsserver'          // 主业务 API（hydro/warn 等）
export const API_BASE_WWW = 'https://www.moodsci.com/lsserver'  // 带 www 的业务 API（历史原因部分接口使用）
export const BACKEND_BASE = 'https://moodsci.com/Backend'       // 区间流量录入等
export const BACKEND_BASE_WWW = 'https://www.moodsci.com/Backend' // 上游流量录入等
export const IMAGES_BACKEND_BASE = 'https://www.moodsci.com/imagesbackend' // 流域边界 GeoJSON
export const WATER_SYSTEM_MVT_URL = 'https://www.moodsci.com/com-api/watersystem/mvt/{z}/{x}/{y}' // 水系矢量瓦片
export const FLOW_ENTRY_URL = 'https://moodsci.com/watherfocast' // 流量录入页面（新窗口打开）
export const FLOW_SUBMIT_URL = 'https://www.glinktop.com/laishui_api/api/hydro/flowEntry' // 流量录入单独使用新服务


// export const API_BASE = 'https://www.moodsci.com/inflowBackend'          // 主业务 API（hydro/warn 等）
// export const API_BASE_WWW = 'https://www.moodsci.com/inflowBackend'  // 带 www 的业务 API（历史原因部分接口使用）
// export const BACKEND_BASE = 'https://moodsci.com/Backend'       // 区间流量录入等
// export const BACKEND_BASE_WWW = 'https://www.moodsci.com/Backend' // 上游流量录入等
// export const IMAGES_BACKEND_BASE = 'https://www.moodsci.com/imagesbackend' // 流域边界 GeoJSON（旧地址）
// export const WATER_SYSTEM_MVT_URL = 'https://www.moodsci.com/com-api/watersystem/mvt/{z}/{x}/{y}' // 水系矢量瓦片
// export const FLOW_ENTRY_URL = 'https://moodsci.com/watherfocast' //

// 首页格点预报跟随统一基础路径，与预报数据页保持一致。
export const GRID_RAINFALL_FORECAST_URL = `${API_BASE_WWW}/api/hydro/gridRainfallForecast`

// 流域面由 imagesbackend 提供，文件名使用站点编码。
export const getStationBasinURL = (stationId) => `${IMAGES_BACKEND_BASE}/json/${stationId}.json`
// 站点图片仍使用主业务服务的静态资源地址。
export const getStationImageURL = (stationId) => `${API_BASE}/upload/hydro/station/${stationId}/image.jpg`
